import { IconCollection } from "components/Icon/IconCollection";
import { ActivityConfig } from "config/config";
import { Action, ActionData } from "containers/Resources/components/CommonActions/Action";
import {
    DeleteListAction,
    PermanentlyDeleteListAction,
    deleteActionSignature,
    deletePermanentlyActionSignature,
    exportActionSignature,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    logsTab,
    logsTabKey,
    referencesUsedByTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import { getRelativeUrl } from "utils/service";
import activity from "./activity";

const identityTypeIconMapping: any = {
    execution: IconCollection.flashOutline,
    schedule: IconCollection.timetable,
    sync_config: IconCollection.sync,
    user: IconCollection.accountOutline,
    webhook: IconCollection.webhook,
};

const OpenIdentityAction: Action = (data, dispatch, history) => {
    const identityId = data.resourceData?.created_by_identity.id;
    const identityType = data.resourceData?.created_by_identity.identity_type?.toLowerCase();
    if (identityId) history.push(getRelativeUrl(identityType, identityId));
    return Promise.resolve(null);
};

const resourceName = "message";

const config: ActivityConfig = {
    label: "Message",
    icon: IconCollection.bellOutline,
    resourceName,
    resourceClass: "activity",
    hideCreateNew: true,
    ignoreIsReadonly: true,
    defaultActiveTab: logsTabKey,
    actions: {
        shown: [
            {
                key: "openIdentity",
                action: OpenIdentityAction,
                icon: (data: any) =>
                    identityTypeIconMapping[
                        data.resourceData?.created_by_identity.identity_type?.toLowerCase()
                    ]
                        ? identityTypeIconMapping[
                              data.resourceData?.created_by_identity.identity_type?.toLowerCase()
                          ]
                        : IconCollection.flashOutline,
                label: (data: any) =>
                    `Open ${data.resourceData?.created_by_identity.identity_type?.toLowerCase()}`,
                href: (data: ActionData) => {
                    const identity = data.resourceData?.created_by_identity;
                    return identity?.id
                        ? getRelativeUrl(identity.identity_type?.toLowerCase(), identity.id)
                        : undefined;
                },
                omitWhen: (data: ActionData) => !data.resourceData?.id,
                submitFormOnAction: false,
            },
        ],
        hidden: [exportActionSignature, deleteActionSignature, deletePermanentlyActionSignature],
        hidePin: true,
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
    layout: [
        {
            partial: "pageHeaderForm",
            config: {
                editName: false,
                showDescription: false,
            },
        },
        { partial: "generateForm" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, referencesUsedByTab.tab],
                content: [logsTab.content, referencesUsedByTab.content],
            },
        },
    ],
    graphql: {
        resource: "message",
        resourceBody: `
            ${activity.graphql.resourceBody}
            subject
            body
            response
            is_submitted
        `,
        updateVariables: `
            ${activity.graphql.updateVariables(resourceName)}
            $response: SchemalessData, 
            $is_submitted: Boolean,
        `,
        updateQuery: `
            ${activity.graphql.updateQuery(resourceName)}
            response: $response,
            is_submitted: $is_submitted,
        `,
    },
};
export default config;
